export const JRCS_ID = "09f08b32-1cbe-4b69-bf51-f3b8a742bc02";